import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import Layout from '../components/Layout';

const QuizInstructions = () => {
  const navigate = useNavigate();

  const instructions = [
    {
      title: "Focus on Present Reality — or Intended Strategic Direction",
      description: "If your brand is already in the market, answer based on its current personality and behavior. If you are building or repositioning a brand, respond based on the intended strategic direction you want the market to perceive — grounded in real consumer need and category opportunity."
    },
    {
      title: "Think in Competitive Context",
      description: "Evaluate the brand within its market landscape. Consider differentiation, category norms, and customer expectations. Your answers should reflect how the brand must position itself to stand out and stay relevant."
    },
    {
      title: "Avoid Aspirational Bias",
      description: "Do not choose traits simply because they sound premium, bold, or desirable. Select what is strategically credible, sustainable, and aligned with your brand's capability and market role."
    },
    {
      title: "Treat the Outcome as Directional",
      description: "The resulting archetype is a strategic framework — not a final verdict. It should be validated and refined through consumer insights, competitive benchmarking, and structured market research before implementation."
    }
  ];

  return (
    <Layout>
      {/* Instructions Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12 md:py-16">
        {/* Title */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Before You Begin
          </h1>
          <p className="text-lg sm:text-xl text-gray-400">
            Please read these important guidelines carefully
          </p>
        </div>

        {/* Instructions List */}
        <div className="space-y-6 sm:space-y-8 mb-10 sm:mb-12">
          {instructions.map((instruction, index) => (
            <div key={index} className="bg-gray-900 rounded-xl border-2 border-gray-800 p-6 sm:p-8 hover:border-gray-700 transition-colors">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #00cffd, #7b00eb)' }}>
                    <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">
                    {index + 1}. {instruction.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
                    {instruction.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            size="lg"
            onClick={() => navigate('/quiz')}
            style={{ background: 'linear-gradient(to right, #00cffd, #7b00eb)' }}
            className="text-white hover:opacity-90 px-8 py-5 text-base sm:text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all min-w-[200px] max-w-[320px] h-14 sm:h-16"
          >
            I Understand - Start Quiz
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <p className="mt-4 text-base text-gray-500">
            Quiz takes approximately 5-7 minutes to complete
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default QuizInstructions;
